<header class="header">

  <!-- Hamburger (mobile / tablet < 1280px only) -->
  <button
    class="header__burger"
    type="button"
    aria-label="Ouvrir ou fermer le menu de navigation"
    (click)="toggleSidebar.emit()"
  >
    <svg class="header__burger-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  </button>

  <!-- Today's date -->
  <div class="header__date">
    <span class="header__date-text">{{ today() }}</span>
  </div>

  <div class="header__actions">

    <!-- Global search -->
    <div class="header__search">
      <svg class="header__search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 15.803 7.5 7.5 0 0015.803 15.803z" />
      </svg>
      <input
        class="header__search-input"
        type="search"
        placeholder="Rechercher…"
        aria-label="Recherche globale"
        [value]="searchQuery()"
        (input)="searchQuery.set($any($event.target).value)"
      />
    </div>

    <!-- Creditor selector -->
    <div class="header__creditor">
      <button
        class="header__creditor-btn"
        type="button"
        aria-haspopup="listbox"
        [attr.aria-expanded]="creditorOpen()"
        [class.header__creditor-btn--open]="creditorOpen()"
        (click)="toggleCreditor()"
      >
        <span class="header__creditor-name">{{ creditors.active()?.name ?? '—' }}</span>
        <svg class="header__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>

      @if (creditorOpen()) {
        <ul class="header__creditor-list" role="listbox" aria-label="Sélectionner un créancier">
          @for (c of creditors.creditors(); track c.id) {
            <li
              class="header__creditor-item"
              [class.header__creditor-item--active]="c.id === creditors.active()?.id"
              role="option"
              [attr.aria-selected]="c.id === creditors.active()?.id"
              tabindex="0"
              (click)="selectCreditor(c.id)"
              (keydown.enter)="selectCreditor(c.id)"
            >
              <span class="header__creditor-code">{{ c.code }}</span>
              <span class="header__creditor-fullname">{{ c.name }}</span>
            </li>
          }
        </ul>
      }
    </div>

    <!-- Role preview selector -->
    <div class="header__role-switcher">
      <span class="header__role-switcher-label" aria-hidden="true">Vue :</span>
      <select
        class="header__role-select"
        [value]="currentRole()"
        (change)="onRoleChange($any($event.target).value)"
        aria-label="Prévisualiser un rôle"
      >
        @for (role of availableRoles; track role) {
          <option [value]="role">{{ roleLabelOf(role) }}</option>
        }
      </select>
    </div>

    <!-- Agent info -->
    <div class="header__agent">
      <div class="header__agent-avatar" aria-hidden="true">{{ user().avatarInitials }}</div>
      <div class="header__agent-info">
        <span class="header__agent-name">{{ user().name }}</span>
        <span class="header__role-badge">{{ roleLabel() }}</span>
      </div>
    </div>

    <!-- Notification bell -->
    <div class="header__notif">
      <button
        class="header__notif-btn"
        type="button"
        aria-label="Notifications"
        [class.header__notif-btn--open]="notifOpen()"
        (click)="toggleNotifications()"
      >
        <svg class="header__bell" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
        </svg>
        @if (notifs.unreadCount() > 0) {
          <span class="header__notif-badge" aria-label="{{ badgeLabel() }} notifications non lues">
            {{ badgeLabel() }}
          </span>
        }
      </button>

      @if (notifOpen()) {
        <mc-notification-center (closed)="notifOpen.set(false)" />
      }
    </div>

  </div>
</header>
